import { getConditionalObject } from 'utils/data';

export class OptimalBluePricingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getPriceConcessionConfiguration(applicationId, params) {
    return this.#http.get(`/api/optimal-blue/price-concession/configuration`, {
      params: { applicationId, ...params },
    });
  }

  async getCustomFields({ applicationId }) {
    return this.#http.get(`/api/optimal-blue/application/${applicationId}/custom-fields`, {
      params: {},
    });
  }

  async getLaunchUrl({ applicationId }) {
    return this.#http.get(`/api/optimal-blue/application/${applicationId}/launch-ui`);
  }

  async getStrategiesAccounts({ companyId } = {}) {
    return this.#http.get(
      '/api/optimal-blue/strategies/accounts',
      getConditionalObject(companyId, () => ({ params: { companyId } })),
    );
  }

  async getConfiguration({ companyId } = {}) {
    return this.#http.get(
      '/api/optimal-blue/configuration',
      getConditionalObject(companyId, () => ({ params: { companyId } })),
    );
  }

  async editConfiguration({ companyId, ...body } = {}) {
    return this.#http.post(
      '/api/optimal-blue/configuration',
      body,
      getConditionalObject(companyId, () => ({ params: { companyId } })),
    );
  }

  async getAccountStrategy({ accountId, companyId } = {}) {
    return this.#http.get(
      `/api/optimal-blue/strategies/accounts/${encodeURIComponent(accountId)}`,
      getConditionalObject(companyId, () => ({ params: { companyId } })),
    );
  }
}
